<template>
  <div class="select-none">
    <header>
      <h1 class="font-semibold text-2xl lg:text-3xl">
        {{ selectedCategory.uuid ? 'Edit Category' : 'New Category' }}
      </h1>
    </header>
    <section class="mt-10">
      <form class="px-2" enctype="multipart/form-data" @submit="submit">
        <fieldset>
          <label for="name">Title<small>*</small></label>
          <input
              id="name"
              v-model="selectedCategory.title"
              class="input mt-2"
              required
              type="text"
          />
        </fieldset>
        <fieldset class="mt-4">
          <label for="name">Name<small>*</small></label>
          <input
              id="name"
              v-model="selectedCategory.name"
              class="input mt-2"
              required
              type="text"
          />
        </fieldset>
        <fieldset class="mt-4">
          <label for="description">Description<small>*</small></label>
          <textarea
              id="description"
              v-model="selectedCategory.description"
              class="textarea mt-2"
              required
          />
        </fieldset>
        <fieldset class="mt-4 sm:max-w-xs">
          <div class="flex items-center justify-between">
            <label for="items_quantity">Number of Items<small>*</small></label>
            <v-popover placement="bottom-start" trigger="hover">
              <button class="btn" type="button">
                <img
                    alt="BuildaBox Order Process"
                    src="@/assets/icons/ic_info.png"
                />
              </button>
              <div slot="popover">
                <div class="w-64 p-4 text-gray-600">
                  Enter the number of items that an attendee may select from a
                  category in their order
                </div>
              </div>
            </v-popover>
          </div>
          <input
              id="items_quantity"
              v-model="selectedCategory.items_quantity"
              class="input mt-2"
              required
              type="number"
          />
        </fieldset>
        <fieldset class="mt-8 flex flex-col sm:flex-row">
          <div
              class="w-40 h-40 rounded border-2 border-gray-400 flex items-center overflow-hidden mx-auto sm:mx-0"
          >
            <img
                v-if="selectedCategoryImage"
                :src="selectedCategoryImage"
                alt="BuildaBox Order Details Page"
            />
          </div>
          <input
              id="image"
              accept=".jpg, .jpeg, .png"
              hidden
              name="image"
              type="file"
              @change="onSelectImage"
          />
          <label
              class="btn btn-secondary rounded-lg px-10 sm:self-end sm:ml-10 text-center mt-2 font-semibold"
              for="image"
          >
            + Upload Image
          </label>
        </fieldset>

        <fieldset class="mt-8">
          <CustomCheckBox :checked="selectedCategory.visible_on_enrollment_page" type="empty"
                          @change="value => selectedCategory.visible_on_enrollment_page = value ">
            <span class="ml-2">Show after attendee enrollment page</span>
          </CustomCheckBox>
        </fieldset>

        <fieldset class="mt-16">
          <div class="flex flex-col-reverse sm:flex-row justify-between">
            <button
                class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 mt-5 sm:mt-0"
                type="button"
                @click="$emit('cancel')"
            >
              <span>Close</span>
            </button>
            <button
                :disabled="!canSubmit"
                class="btn btn-primary font-semibold rounded-lg px-10 min-w-10"
                type="submit"
            >
              <span v-if="!progressSaving">Save</span>
              <Spinner v-if="progressSaving" class="mx-auto"/>
            </button>
          </div>
        </fieldset>
      </form>
    </section>
  </div>
</template>

<script>
import Spinner from '@/components/common/Spinner'
import { maxLength, minLength, required, requiredIf } from 'vuelidate/lib/validators'
import Api from '@/api/api_v1.0'
import CustomCheckBox from '@/components/CustomCheckBox.vue'

export default {
  components: { Spinner, CustomCheckBox },
  props     : {
    orderUuid: String,
    category : Object
  },
  data () {
    return {
      selectedCategory: '',
      progressSaving  : false
    }
  },
  computed   : {
    selectedCategoryImage () {
      if (this.selectedCategory.file) {
        return URL.createObjectURL(this.selectedCategory.file)
      } else {
        return this.selectedCategory.image
      }
    },
    canSubmit () {
      return !this.$v.$invalid
    }
  },
  validations: {
    selectedCategory: {
      title         : { required, minLength: minLength(2), maxLength: maxLength(50) },
      name          : { required },
      description   : { required },
      items_quantity: { required },
      file          : {
        required: requiredIf(function () {
          return !this.selectedCategoryImage
        })
      }
    }
  },
  mounted () {
    this.selectedCategory = this.category
  },
  methods: {
    onSelectImage (event) {
      this.selectedCategory.file = event.target.files[0]
    },
    async submit (event) {
      event.preventDefault()
      this.progressSaving = true
      Api.saveCategoryForOrder(this.orderUuid, this.selectedCategory)
         .then(() => {
           this.progressSaving = false
           this.$emit('submit')
         })
         .catch(() => {
           this.progressSaving = false
         })
    }
  }
}
</script>
